export const DRAFT = "DRAFT";
export const PUBLISHED = "PUBLISHED";
